import { useState, useEffect } from 'react';
import { useToggle, } from 'react-use';

import { countRead } from '../../firestoreReadCounter';

export default function useCollectionSubscription (ref, dependencies = [], { initialItems = [], detail = false, } = {}) {
  const [items, setItems] = useState(initialItems);
  const [isLoading, toggleLoading] = useToggle(false);
  useEffect(() => {
    if(!ref) return setItems([]);

    toggleLoading(true);
    const unsubscribe = ref
      .onSnapshot(({ docs }) => {
        countRead(docs[0]?.ref?.parent, docs.length);
        setItems(docs.map(_ => ({ id: _.id, ref: _.ref, ..._.data() })));
        toggleLoading(false);
      });
    return unsubscribe;
  }, dependencies);
  return detail ? { items, isLoading } : items;
};
